<div #copyLink class="copy-link-container">
  <ng-container *ngIf="!isLinkCopied; else copied">
    <div *ngIf="hasAccess()" class="copy-link" kendoTooltip filter=".copy-link" position="right" [title]="miscStrings.clickToCopyLink">
      <span class="copy-link-title">{{_itemId}}</span>
      <span class="copy-link-icon fa fa-link fa-flip-horizontal"></span>
    </div>
    <span *ngIf="!hasAccess()" class="copy-link-title">{{_itemId}}</span>
  </ng-container>
</div>

<ng-template #copied>
  <div class="copied">
    <span class="copied-icon fa fa-check"></span>
    <span class="copied-text">{{miscStrings.copied}}</span>
  </div>
</ng-template>


